<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { iModal, openModal, showToast } from '@inscribe/signal';

export default {
  components: {
    iModal,
  },
  props: {
    checkToBeDeleted: {
      type: Object,
      default: null,
    },
  },
  watch: {
    checkToBeDeleted(value) {
      if (value) {
        openModal('delete-checks-modal');
      }
    },
  },
  methods: {
    ...mapActions({
      deleteCheck: 'deleteCheck',
    }),
    ...mapGetters({ getChecks: 'getChecks' }),
    ...mapMutations({
      setChecks: 'setChecks',
    }),
    onClose() {
      this.$emit('on-close');
    },
    onSubmit() {
      const checkToBeDeletedId = this.checkToBeDeleted.id;
      if (!checkToBeDeletedId) {
        this.$emit('on-deleted');
      } else {
        this.deleteCheck(checkToBeDeletedId)
          .then(() => {
            const newChecks = this.getChecks().filter((check) => {
              return check.id !== checkToBeDeletedId;
            });
            this.setChecks(newChecks);
            showToast({
              text: 'Document check deleted',
            });
            this.$emit('on-deleted');
          })
          .catch((error) => {
            showToast({
              text: error?.response?.data?.message || 'Please try again later.',
              isError: true,
            });
          });
      }
    },
  },
};
</script>

<template>
  <div class="wrapper">
    <i-modal
      modal-id="delete-checks-modal"
      data-testid="delete-checks-modal"
      title="Delete Document Check"
      confirm-button-text="Delete"
      type="error"
      @on-submit="onSubmit"
      @on-close="onClose"
    >
      <template #body-content>
        <div>Are you sure you want to delete this check?</div>
      </template>
    </i-modal>
  </div>
</template>
